import { injectable } from 'inversify';
import { ObjectManager } from '../../../concepts/objects';
import { ActiveObject, resolve } from '../../Container';
import { EditorSession } from '../../canvas/EditorSession';
import { ToolInfo } from '../../canvas/tooling/ToolInfo';
import { ToolManager } from '../../canvas/tooling/ToolManager';
import { WidgetManager } from '../../canvas/workspace/widgets/WidgetManager';
import { ActiveSketchInfo } from './ActiveSketchInfo';
import { ActiveSketchWidget } from './ActiveSketchWidget';
import { Sketch } from './Sketch';

@injectable()
export class MarkerMechanics extends ActiveObject {

    @resolve(ObjectManager) private objects: ObjectManager;
    @resolve(EditorSession) private session: EditorSession;
    @resolve(ToolManager) private tools: ToolManager;
    @resolve(WidgetManager) private widgets: WidgetManager;

    public start() {
        this.burden(
            this.session.observe(ToolInfo, this.onToolChange),
            this.session.observe(ActiveSketchInfo, this.realizeWidgetForActiveSketch),
        );
    }

    private onToolChange = (next: ToolInfo, prev: ToolInfo) => {
        if ((next.id !== 'markerTool' && next.id !== 'eraserTool') && prev.id === 'markerTool') {
            this.session.update(ActiveSketchInfo, ActiveSketchInfo.empty);
        }
    };

    private realizeWidgetForActiveSketch = (next: ActiveSketchInfo) => {

        const sketch = this.objects.getMaybe(next.sketchId, Sketch);

        if (!sketch?.alive) {
            this.widgets.delete('activeSketch');
        }
        else if (!this.widgets.get('activeSketch')) {

            const cont = this.widgets.createContainer({
                name: 'activeSketch',
                position: ['unmanaged'],
                style: 'none',
            });

            cont.add(this.widgets.createInline({
                subject: sketch,
                ui: ActiveSketchWidget,
                onAction: () => {
                    this.session.update(ActiveSketchInfo, ActiveSketchInfo.empty);
                }
            }));

            this.widgets.add(cont);

        }
    };
}
